import { connect } from "react-redux";
import Orders from "./component";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {  toast } from 'react-toastify';

import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { API_BASE_URL } from "../../config";
const OrdersContainer = (props) => {
  const { makeApiRequest } = useApiRequest()
  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");


//console.log("OrderHistory",OrderHistory)
const [orderhistory,setOrderhistory]=useState('')
const [activeOrderhistory,setActiveOrderhistory]=useState('')
const [loader,setLoader]=useState(true);



const [gmail,setGmail]=useState(null)


  const [google_Pop_flag, setGoogle_Pop_flag] = useState(false);
  const [google_OTP_Pop_flag, setGoogle_OTP_Pop_flag] = useState(false);
  const [google_success_flag, setGoogle_success_flag] = useState(false);


    const [number, setNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [google_requestId, setGoogle_requestId] = useState(null);
    const [numberError, setNumberError] = useState(false);
    const [otpError, setOtpError] = useState(false);
    const [numberErrorMsg, setNumberErrorMsg] = useState("");
    const [otpErrorMsg, setOtpErrorMsg] = useState("");

const navigate=useNavigate()
useEffect(()=>{
  if(localStorage.getItem("google_jwt")){
    //setGoogle_Pop_flag(true)
  }
  if(navigator.onLine){
  fetchOrderHistory()
  fetchUserDetails()
  fetchActiveOrderHistory()
}
else{
  setLoader(false)
}
},[])

  const fetchUserDetails = () => {
    if (!token) return;

    makeApiRequest({
      //url: `https://api-prod.daalchini.co.in/auth/user/profile/details`,
      url: `${API_BASE_URL}/auth/user/profile/details`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: {
        request: { oauthToken: `Bearer ${token}` },
      },
      handleSuccess: handleResponseUserDetails,
      handleError: handleErrorUserDetails,
    });
  };

  const handleResponseUserDetails = (res) => {
console.log("handleResponseUserDetails",res.data.response)


    const data = res?.data?.response;
    if (data) {
      localStorage.setItem("referCode", data.referCode);
      //setProfileData(data);
    }
    setLoader(false);
  };

  const handleErrorUserDetails = (error) => {
    setLoader(false);
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      const google_jwt = localStorage.getItem("google_jwt");
      if(google_jwt) { 
        setGoogle_Pop_flag(true)

      } 
    } else {
      toast.error(
        error?.response?.data?.status || "Something went wrong",
        { position: "top-right", autoClose: 1000 }
      );
    }
  };

    
useEffect(()=>{
  //mpClick({EventName:"past_orders_page_opened"})
},[])
const UserJWTAuth = localStorage.getItem('UserJWTAuth');
useEffect(()=>{
 
 //console.log("UserJWTAuth BusinessPaymentContainer",UserJWTAuth)
 if(!UserJWTAuth){
   navigate('/')
 }
},[])
useEffect(()=>{
 
  //console.log("UserJWTAuth BusinessPaymentContainer",UserJWTAuth)
  if(localStorage.getItem('Guest_clientId')){
    navigate('/login?route=orders')
  }
  
 },[])
 


  const googleAddnumber = () => {
    if (number.length !== 10) {
      setNumberError(true);
      setNumberErrorMsg("Enter a valid mobile number");
      return;
    }

    setNumberError(false);
    makeApiRequest({
      //url: `https://api-prod.daalchini.co.in/auth/user/authenticate`,
      url: `${API_BASE_URL}/auth/user/authenticate`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: {
        request: {
          mobileNo: number,
          googleId: localStorage.getItem("gmail"),
        },
      },
      handleSuccess: (res) => {
        setGoogle_requestId(res.data.response.requestId);
        setGoogle_Pop_flag(false);
        setGoogle_OTP_Pop_flag(true);
      },
      handleError: (err) => {
        setNumberError(true);
        setNumberErrorMsg(err.response.data.statusMessage);
        toast.error(err.response.data.statusMessage, {
          position: "top-right",
          autoClose: 1000,
        });
      },
    });
  };

  const googleOtpSubmit = () => {
    if (otp.length !== 4) {
      setOtpError(true);
      return;
    }

    setOtpError(false);

    makeApiRequest({
      //url: `https://api-prod.daalchini.co.in/auth/user/login`,
      url: `${API_BASE_URL}/auth/user/login`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: {
        request: {
          deviceId: deviceId,
          fcmUserToken: null,
          mobileNo: number,
          otp: otp,
          requestId: google_requestId,
          sourcePlatform: "web",
        },
      },
      handleSuccess: (res) => {
        const response = res?.data?.response;
        if (response) {
          setGoogle_success_flag(true);
          setGoogle_OTP_Pop_flag(false);
          localStorage.setItem("UserJWTAuth", response.jwt);
          localStorage.setItem("referCode", response.referCode);
          localStorage.setItem("isUserLogged", response.isUserLogged);
          localStorage.setItem("isGuest", response.isGuest);
          localStorage.setItem("isTokenExpired", response.isTokenExpired);
        } else if (res?.data?.status === "FAILURE") {
          setOtpError(true);
          setOtpErrorMsg(res?.data?.statusMessage);
          toast.error(res?.data?.statusMessage, {
            position: "top-right",
            autoClose: 1000,
          });
        }
      },
      handleError: () => setOtpError(true),
    });
  };
 

 const closePop=(e)=>{
  setGoogle_Pop_flag(false);
  //console.log("localStorage.getItem(",localStorage.getItem("machineId"))
  if(!(localStorage.getItem("machineId")==null)){
  navigate(`/`)
  }
  else{
    navigate('/')
  }
}




const fetchActiveOrderHistory = () => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");



  makeApiRequest({
    //url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/order/active`,
    url: `${API_BASE_URL}/consumerbe/api/v2/order/active`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId,
    },
    data: {
     request:{}
    },
    handleSuccess: (res) => {
      //console.log("✅ Payment Initiated Successfully:", res);
      handleResponseActiveOrderHistory(res);
    },
    handleError: (err) => {
      //console.error("❌ Payment Initiation Failed:", err);
      handleErrorActiveOrderHistory(err);
    },
  });

};



const handleErrorActiveOrderHistory=(error)=>{
  //console.log("res")
  if(error.response.status==401|| error.response.status==403){

   // console.log("khan handleErrorVmInventory", error.response.data.status.code);
    //Logout
    //localStorage.removeItem("UserJWTAuth")
      navigate("/login");
}
else{ toast.error(`${error.response.data.status.code}`, {
  position: "top-right",
  autoClose: 1000,
});
}
  setLoader(false)
}

const handleResponseActiveOrderHistory=(res)=>{
  //console.log("handleResponseOrderHistory",res.data.data)
  setActiveOrderhistory(res.data.data)
  setLoader(false)
}



const fetchOrderHistory = () => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");



  makeApiRequest({
    //url: `https://api-prod.daalchini.co.in/order/order/orderhistory`,
    url: `${API_BASE_URL}/order/order/orderhistory`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId,
    },
    data: {
     request:{}
    },
    handleSuccess: (res) => {
      //console.log("✅ Payment Initiated Successfully:", res);
      handleResponseOrderHistory(res);
    },
    handleError: (err) => {
      //console.error("❌ Payment Initiation Failed:", err);
      handleErrorOrderHistory(err);
    },
  });

};



const handleErrorOrderHistory=(error)=>{
  //console.log("error---------------",error)
  if(error.response.status==401|| error.response.status==403){

   // console.log("khan handleErrorVmInventory", error.response.data.status.code);
    //Logout
    //localStorage.removeItem("UserJWTAuth")
      navigate("/login");
}
else{ toast.error(`${error.response.data.status.code}`, {
  position: "top-right",
  autoClose: 1000,
});
}
  setLoader(false)
}

const handleResponseOrderHistory=(res)=>{
  //console.log("handleResponseOrderHistory",res.data.response)
  setOrderhistory(res.data.response)
  setLoader(false)
}



const handle_Number = (e) => {
  e.preventDefault(); // Prevent default action (if needed)
 // console.log("number", e.target.value);
  setNumber(e.target.value); // Update the state with the new value
};




const handleResponsegoogleAddnumber=(res)=>{
// console.log("setGoogle_requestId",res.data.response.requestId)
 setGoogle_requestId(res.data.response.requestId)
  setGoogle_Pop_flag(false)
  setGoogle_OTP_Pop_flag(true)
  
 

}

const handleErrorgoogleAddnumber=(err)=>{
  //console.log("handleErrorgoogleAddnumber",err.response.data.statusMessage)
  toast.error(`${err.response.data.statusMessage}`, {
    position: "top-right",
    autoClose: 1000,
  });
  setNumberError(true)
  setNumberErrorMsg(err.response.data.statusMessage)
  
}






const handleResponsegoogleOtp=(res)=>{
  //console.log("handleResponsegoogleOtp",res.data.response,res.data.status,res.data.statusMessage)
  if(res&&res.data&&res.data.response){

  setGoogle_success_flag(true)
  setGoogle_OTP_Pop_flag(false)

  localStorage.setItem("UserJWTAuth",res.data.response.jwt)
  localStorage.setItem("referCode",res.data.response.referCode)
  localStorage.setItem("isUserLogged",res.data.response.isUserLogged)
  localStorage.setItem("isGuest",res.data.response.isGuest)
  localStorage.setItem("isTokenExpired",res.data.response.isTokenExpired)
  }
 if(res&&res.data&&res.data.status=="FAILURE"){

  setOtpError(true)

  setOtpErrorMsg(res&&res.data&&res.data.statusMessage)
 }

}

const handleErrorgoogleOTp=()=>{

}



const closeOTpPop=(e)=>{
  setGoogle_Pop_flag(true);
 
setGoogle_OTP_Pop_flag(false)
}










return(
    <Orders
    orderhistory={orderhistory}
    activeOrderhistory={activeOrderhistory}
    loader={loader}
    setGoogle_Pop_flag={setGoogle_Pop_flag}

    google_Pop_flag={google_Pop_flag}
    closePop={closePop}
    handle_Number={handle_Number}
    googleAddnumber={googleAddnumber}
    number={number}
    setNumber={setNumber}
    setGoogle_OTP_Pop_flag={setGoogle_OTP_Pop_flag}
    google_OTP_Pop_flag={google_OTP_Pop_flag}
    closeOTpPop={closeOTpPop}
    numberError={numberError}
    googleOtpSubmit={googleOtpSubmit}
    setOtp={setOtp}
    otp={otp}
    otpError={otpError}
    otpErrorMsg={otpErrorMsg}
    setGoogle_success_flag={setGoogle_success_flag}
    google_success_flag={google_success_flag}
    numberErrorMsg={numberErrorMsg}
   
    
    />
)


}




  export default  OrdersContainer